import { money } from "@/lib/api";

const STATUT = { accepte: "acceptée", refuse: "refusée", quitte: "départ du locataire" };

const lignes = (l) => {
  const p = l.paliers || [];
  const h = l.hausse;
  const res = [{ date: "", loyer: p[0]?.ancien ?? h?.ancien ?? l.loyer_habituel, source: "Loyer de départ" }];
  p.forEach((x) => res.push({ date: x.a_partir_de, loyer: x.nouveau, source: x.source === "tal" ? "Décision du TAL" : "Hausse" }));
  if (h?.decision) res.push({ date: h.decision.date_effet, loyer: h.decision.loyer, source: `Décision du TAL du ${h.decision.date_decision}` });
  else if (h) res.push({ date: h.a_partir_de, loyer: h.nouveau, source: `Hausse ${STATUT[h.reponse] || "proposée (sans réponse)"}`, barre: ["refuse", "quitte"].includes(h.reponse) });
  return res;
};

export const HistoriqueLoyers = ({ l }) => (
  <div className="w-full rounded-md bg-slate-50 px-3 py-2" data-testid={`historique-loyers-${l.id}`}>
    <p className="text-[11px] font-mono uppercase tracking-wider text-slate-500">Historique des loyers</p>
    <ul className="mt-1 space-y-0.5 text-xs">
      {lignes(l).map((x, i) => (
        <li key={i} className={`flex flex-wrap gap-x-3 ${x.barre ? "text-slate-400 line-through" : "text-slate-700"}`}>
          <span className="w-24 font-mono">{x.date || "—"}</span><span className="w-24 font-mono text-right">{money(x.loyer)}</span><span>{x.source}</span>
        </li>
      ))}
    </ul>
  </div>
);
